import { render, staticRenderFns } from "./DialogSetupStatus.vue?vue&type=template&id=1238e1c2&scoped=true&"
import script from "./DialogSetupStatus.vue?vue&type=script&lang=ts&"
export * from "./DialogSetupStatus.vue?vue&type=script&lang=ts&"
import style0 from "./DialogSetupStatus.vue?vue&type=style&index=0&id=1238e1c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1238e1c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
